import React from "react"
import styled from "styled-components"
import SocialLinks from "../constants/socialLinks"
import { Link } from "gatsby"
import FootTop from "./Footer-Top"

const Footer = ({footerTop=true}) => {
  
  return (
    <Wrapper>
      {footerTop &&
        <FootTop />
      }
      

      <div className="white-line"></div>

      <div className="footer-bottom">
        <div className="flex copy">
          &copy; Shopifysystems, {new Date().getFullYear()}
        </div>

        <div className="flex flex-links">
          <Link to="#">Privacy Policy</Link>
          <Link to="#">Terms of Service</Link>
          <Link to="#">Cookie Policy</Link>
        </div>

        <div className="flex follow">
          Follow us:
          <SocialLinks styleClass="footer-links" />
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.footer`  
  color: var(--clr-white);
  text-align: center;



  

  /* Second part (bottom) elements */
  .footer-bottom {
    
    background: var(--clr-primary-1);   
    padding: 1rem 3rem;
    display: flex;
    flex-direction: column;
    gap: 14px;
    

    @media (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      padding: 1rem 0;
    }
    @media (min-width: 1025px) {padding: 20px 135px;}
    
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    a {
      color: var(--clr-white);
    }
  }

  .copy {margin: 12px 0;}

  .flex-links {
    flex-direction: column;
    line-height: 190%;
    a {
      margin-bottom: 8px;
    }
    @media screen and (min-width: 768px) {
      flex-direction: row;
      gap: 24px;
      a {
      margin-bottom: 0px;
    }
    }
  }

  .follow {
    order: -2;
    @media screen and (min-width: 768px) {
      order: 0;
    }
  }

  .white-line {
    background: var(--clr-white);
    color: var(--clr-primary-1);
    height: 3px;
  }

  .footer-links {
    margin: 0;
    width: 8rem;
    margin-left: 1.5rem;
  }
  .social-link {
    color: var(--clr-white);
    font-size: 1.25rem;
  }
  .social-link:hover {
    color: var(--clr-primary-2);
  }
`

export default Footer
